/**
 * A list of pathnames that, if matched with the page browser, forces a Connector Grid send.
 * 
 * Steps for adding URLs:
 * 1. URLS must be absolute paths
 * 2. Please remove any query params from URL
 *    (e.g. https://www.bmo.com/path-name/?icid=12345 ==> https://www.bmo.com/path-name/)
 *    Only the URL Pathname will be compared
 * 
 * @constant
 * @type (AbsoluteURL[])
 * @author Jaskiran Chhokar
 */

export type AbsoluteURL = `${'http' | 'https'}://${string}`;

const defaultUrlWhitelist: AbsoluteURL[] = [
    'https://www.bmo.qa2.bmo.com/en-ca/main/business/news/open-a-business-bank-account/',
    'https://www.bmo.qa2.bmo.com/fr-ca/principal/entreprise/nouvelles/ouvrir-un-compte-bancaire-dentreprise/',
    'https://www.bmo.qa2.bmo.com/en-ca/main/personal/bank-accounts/savings-accounts/how-to-save-money/',
    'https://www.bmo.qa2.bmo.com/fr-ca/principal/particuliers/comptes-bancaires/comptes-depargne/comment-epargner/',
    'https://www.bmo.qa2.bmo.com/en-ca/main/personal/canadian-defence-community-banking/',
    'https://www.bmo.qa2.bmo.com/fr-ca/principal/particuliers/services-bancaires-pour-la-communaute-de-la-defense-canadienne/',
    'https://www.bmo.qa2.bmo.com/en-ca/main/personal/credit-cards/affinity/university-college-alumni/bmo-university-british-columbia-mastercard/cb/',
    'https://www.bmo.qa2.bmo.com/fr-ca/principal/particuliers/cartes-de-credit/affinite/diplomes-universitaires-et-collegiaux/mastercard-bmo-universite-colombie-britannique/cb/', 
    'https://www.bmo.qa2.bmo.com/en-ca/main/personal/investments/options/',
    'https://www.bmo.qa2.bmo.com/fr-ca/principal/particuliers/investissements/options/',
    'https://www.bmo.qa2.bmo.com/en-ca/main/personal/ways-to-bank/debit-cards/',
    'https://www.bmo.qa2.bmo.com/fr-ca/principal/particuliers/vos-operations-bancaires/cartes-de-debit/',
    'https://www.bmo.qa2.bmo.com/en-us/main/personal/security-center/learning-center/social-media-tips/',
    'https://www.bmo.qa2.bmo.com/en-us/main/personal/security-center/security-checklist/'
];

export default defaultUrlWhitelist;